import { render, staticRenderFns } from "./SpecialLinkRichAlt.vue?vue&type=template&id=ab28361a&"
import script from "./SpecialLinkRichAlt.vue?vue&type=script&lang=js&"
export * from "./SpecialLinkRichAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports